// extracted by mini-css-extract-plugin
module.exports = {"error":"_6c97079b1b--error--t8OU2","button":"_6c97079b1b--button--BBQ1K"};